module.exports = __webpack_public_path__ + "static/media/pic3.a89e470e.jpg";